import * as AF from "@/components/form-items/AbstractForm";
import { useTranslation } from "react-i18next";

export interface LegalNoticesFormProps {
  formBase: string;
}

export const LegalNoticesForm = ({ formBase }: LegalNoticesFormProps) => {
  const { t } = useTranslation();
  return (
    <AF.Col>
      <AF.Text
        name={`${formBase}.pageName`}
        label={t("cms.legalNotices.form.pageName")}
      />
      <AF.RichText
        name={`${formBase}.content`}
        label={t("cms.legalNotices.form.content")}
      />
    </AF.Col>
  );
};

export const GcuForm = ({ formBase }: LegalNoticesFormProps) => {
  const { t } = useTranslation();
  return (
    <AF.Col>
      <AF.Text
        name={`${formBase}.pageName`}
        label={t("cms.gcu.form.pageName")}
      />
      <AF.RichText
        name={`${formBase}.content`}
        label={t("cms.gcu.form.content")}
      />
    </AF.Col>
  );
};

export const PrivacyPolicyForm = ({ formBase }: LegalNoticesFormProps) => {
  const { t } = useTranslation();
  return (
    <AF.Col>
      <AF.Text
        name={`${formBase}.pageName`}
        label={t("cms.privacyPolicy.form.pageName")}
      />
      <AF.RichText
        name={`${formBase}.content`}
        label={t("cms.privacyPolicy.form.content")}
      />
    </AF.Col>
  );
};
